var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileApp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 114.54 122.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mobile-and-tablet") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.1,4V18.72H79.7V7.1H6v98.46H50.08v9.5a18.13,18.13,0,0,0,1.41,7c.11.27.22.53.35.8H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0H81.11a4,4,0,0,1,4,4ZM70.56,31.05H105a9.53,9.53,0,0,1,9.51,9.51v72.81a9.53,9.53,0,0,1-9.51,9.51H70.56a9.53,9.53,0,0,1-9.51-9.51V40.55a9.51,9.51,0,0,1,9.51-9.5Zm-6.23,78.62h46.92V41.42H64.33v68.25Zm23.45,3a3.91,3.91,0,1,1-3.91,3.91,3.9,3.9,0,0,1,3.91-3.91ZM40.64,109.6a4.57,4.57,0,1,1-4.56,4.56,4.56,4.56,0,0,1,4.56-4.56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileApp);
export default __webpack_public_path__ + "static/media/mobile_app.9f6f1ab936990295a92cfb0b0c2bde64.svg";
export { ForwardRef as ReactComponent };